import * as battery0 from '@/../images/device_icons/default/battery0.svg'
import * as battery20 from '@/../images/device_icons/default/battery20.svg'
import * as battery40 from '@/../images/device_icons/default/battery40.svg'
import * as battery60 from '@/../images/device_icons/default/battery60.svg'
import * as battery80 from '@/../images/device_icons/default/battery80.svg'
import * as battery100 from '@/../images/device_icons/default/battery100.svg'
import * as chp from '@/../images/device_icons/default/chp.svg'
import * as container from '@/../images/device_icons/default/container.svg'
import * as containerAlarm from '@/../images/device_icons/default/container_alarm.svg'
import * as containerOk from '@/../images/device_icons/default/container_ok.svg'
import * as containerWarning from '@/../images/device_icons/default/container_warning.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/default/coreui_device_icons'
import * as dashboardCenterIcon from '@/../images/device_icons/default/dashboard_center_icon.svg'
import * as factory from '@/../images/device_icons/default/factory.svg'
import * as fuelcell from '@/../images/device_icons/default/fuelcell.svg'
import * as generic from '@/../images/device_icons/default/generic.svg'
import * as grid from '@/../images/device_icons/default/grid.svg'
import * as gridOffgrid from '@/../images/device_icons/default/grid_offgrid.svg'
import * as heatingelement from '@/../images/device_icons/default/heatingelement.svg'
import * as heatpump from '@/../images/device_icons/default/heatpump.svg'
import * as pv from '@/../images/device_icons/default/pv.svg'
import * as rest from '@/../images/device_icons/default/rest.svg'
import * as trafo from '@/../images/device_icons/default/trafo.svg'
import * as user from '@/../images/device_icons/default/user.svg'
import * as wallboxPlugged from '@/../images/device_icons/default/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/device_icons/default/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/device_icons/default/wallbox_warning.svg'

export const ICON_MAPPING = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  container,
  containerAlarm,
  containerOk,
  containerWarning,
  dashboardCenterIcon,
  factory,
  fuelcell,
  generic,
  grid,
  gridOffgrid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox: wallboxUnplugged,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export const COREUI_DEVICE_ICON_MAPPING = {
  ...coreuiDeviceIcons
}
